import * as z from 'zod';

import { withLogs } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

const liveAnalysisEnabledSchema = z.object({
    enabled: z.boolean(),
});

type LiveAnalysisEnabled = z.infer<typeof liveAnalysisEnabledSchema>;

export const getLiveAnalysisEnabled = withLogs(
    () =>
        apiClient
            .get<LiveAnalysisEnabled>(ApiConfig.path('/api/v1/live-feedback/enabled'))
            .then((config) => liveAnalysisEnabledSchema.parse(config.data)),
    'getLiveAnalysisEnabled',
);
